import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions';
import validate from 'validate.js';
import _ from 'lodash';
import './dialog.css';

const validateLogin = {
    email: {
        presence: { allowEmpty: false, message: 'is required' },
        email: true
    },
    password: {
        presence: { allowEmpty: false, message: 'is required' },
        length: { minimum: 6 }
    }
};

const validateRegister = {
    email: {
        presence: { allowEmpty: false, message: 'is required' },
        email: true
    },
    password: {
        presence: { allowEmpty: false, message: 'is required' },
        length: { minimum: 6 }
    },
    name: {
        presence: { allowEmpty: false, message: 'is required' }
    },
    lastname: {
        presence: { allowEmpty: false, message: 'is required' }
    }
};

const validateReset = {
    email: {
        presence: { allowEmpty: false, message: 'is required' },
        email: true
    }
};

const formTemplate = {
    login: {
        isValid: false,
        values: { email: '', password: '' },
        touched: {},
        errors: {}
    },
    register: {
        isValid: false,
        values: { email: '', password: '', name: '', lastname: '' },
        touched: {},
        errors: {}
    },
    reset: {
        isValid: false,
        values: { email: '' },
        touched: {},
        errors: {}
    }
};

class DialogLogin extends Component {
    state = { ...formTemplate };

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevState.login.values, this.state.login.values)) {
            const errors = validate(this.state.login.values, validateLogin);
            this.setState(prevSt => ({
                ...prevSt,
                login: {
                    ...prevSt.login,
                    isValid: errors ? false : true,
                    errors: errors || {}
                }
            }));
        }

        if (!_.isEqual(prevState.register.values, this.state.register.values)) {
            const errors = validate(
                this.state.register.values,
                validateRegister
            );
            this.setState(prevSt => ({
                ...prevSt,
                register: {
                    ...prevSt.register,
                    isValid: errors ? false : true,
                    errors: errors || {}
                }
            }));
        }

        if (!_.isEqual(prevState.reset.values, this.state.reset.values)) {
            const errors = validate(this.state.reset.values, validateReset);
            this.setState(prevSt => ({
                ...prevSt,
                reset: {
                    ...prevSt.reset,
                    isValid: errors ? false : true,
                    errors: errors || {}
                }
            }));
        }
    }

    handleInputChange = (form, event) => {
        event.persist();

        const { name, value } = event.target;
        this.setState(prevState => ({
            ...prevState,
            [form]: {
                ...prevState[form],
                values: { ...prevState[form].values, [name]: value },
                touched: { ...prevState[form].touched, [name]: true }
            }
        }));
    };

    hasError = (form, field) => {
        const { login, register, reset } = this.state;
        if (form === 'login')
            return login.touched[field] && login.errors[field] ? true : false;
        if (form === 'register')
            return register.touched[field] && register.errors[field]
                ? true
                : false;
        if (form === 'reset')
            return reset.touched[field] && reset.errors[field] ? true : false;
    };

    clearFormInput = () => {
        this.setState({ ...formTemplate });
    };

    handleKeyDown = e => {
        if (e.key === 'Enter') {
            const { login } = this.state;
            const { SignWithEmainAndPassword } = this.props;
            SignWithEmainAndPassword(login.values.email, login.values.password);
        }
    };

    handleRegisterKeyDown = e => {};

    render() {
        const { login, register, reset } = this.state;

        const {
            isSignInForm,
            dialogLogin,
            firebaseAuthError,
            SignInWithFacebook,
            SignWithEmainAndPassword,
            CreateUserWithEmailAndPassword,
            CloseDialogLogin,
            FormChange,
            FirebaseForgetPassword,
            firebaseResetEmail,
            wording
        } = this.props;

        return (
            <Modal
                visible={dialogLogin}
                width='450px'
                style={{ backgroundColor: '#FF0000' }}
                effect='fadeInUp'
                onClickAway={() => {
                    CloseDialogLogin();
                    this.clearFormInput();
                }}>
                <div>
                    <div className='login-form'>
                        <div
                            className='dialog-header'
                            style={{
                                display: 'flex',
                                justifyContent: 'center'
                            }}>
                            <img
                                className='sf-logo'
                                src='/assets/img/sf/sflogo.png'
                                alt='sflogo.png'
                            />
                        </div>

                        <div className='dialog-action row'>
                            <div className='col-md-12'>
                                <button
                                    className='w-100 btn btn-lg btn-facebook'
                                    onClick={() => SignInWithFacebook()}>
                                    {wording.homePage.dialogSignIn.signFb}
                                </button>
                            </div>
                        </div>

                        <div className='divided'>
                            <span>{wording.homePage.dialogSignIn.oR}</span>
                        </div>

                        <div className='dialog-body mt-20'>
                            {isSignInForm === 'sign-in' && (
                                <>
                                    <div className='row row-10'>
                                        {firebaseAuthError && (
                                            <div className='col-sm-12'>
                                                <div
                                                    className='alert alert-danger'
                                                    role='alert'>
                                                    {firebaseAuthError.message}
                                                </div>
                                            </div>
                                        )}

                                        <div className='col-sm-12'>
                                            <p className='form-row form-row-wide'>
                                                <input
                                                    name='email'
                                                    type='text'
                                                    className='input-text'
                                                    placeholder={
                                                        wording.homePage
                                                            .dialogSignIn.email
                                                    }
                                                    value={login.values.email}
                                                    onChange={event =>
                                                        this.handleInputChange(
                                                            'login',
                                                            event
                                                        )
                                                    }
                                                />
                                                <span className='error'>
                                                    {this.hasError(
                                                        'login',
                                                        'email'
                                                    )
                                                        ? login.errors.email[0]
                                                        : null}
                                                </span>
                                            </p>
                                        </div>

                                        <div className='col-sm-12'>
                                            <p className='form-row form-row-wide'>
                                                <input
                                                    name='password'
                                                    type='password'
                                                    className='input-text input-login'
                                                    placeholder={
                                                        wording.homePage
                                                            .dialogSignIn
                                                            .password
                                                    }
                                                    value={
                                                        login.values.password
                                                    }
                                                    onChange={event =>
                                                        this.handleInputChange(
                                                            'login',
                                                            event
                                                        )
                                                    }
                                                    onKeyDown={event =>
                                                        this.handleKeyDown(
                                                            event
                                                        )
                                                    }
                                                />
                                                <span className='error'>
                                                    {this.hasError(
                                                        'login',
                                                        'password'
                                                    )
                                                        ? login.errors
                                                              .password[0]
                                                        : null}
                                                </span>
                                            </p>
                                        </div>

                                        <div className='col-sm-12'>
                                            <div className='form-row form-row-wide forget-password pointer'>
                                                <p
                                                    onClick={() =>
                                                        FormChange(
                                                            'forget-password'
                                                        )
                                                    }>
                                                    {
                                                        wording.homePage
                                                            .dialogSignIn
                                                            .forgetPassword
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='dialog-action row'>
                                        <div className='col-md-12'>
                                            <button
                                                className='w-100 btn btn-lg btn-login'
                                                disabled={!login.isValid}
                                                onClick={() => {
                                                    SignWithEmainAndPassword(
                                                        login.values.email,
                                                        login.values.password
                                                    );
                                                    this.clearFormInput();
                                                }}>
                                                {
                                                    wording.homePage
                                                        .dialogSignIn.signIn
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}

                            {isSignInForm === 'sign-up' && (
                                <>
                                    <div className='row row-10'>
                                        {firebaseAuthError && (
                                            <div className='col-sm-12'>
                                                <div
                                                    className='alert alert-danger'
                                                    role='alert'>
                                                    {firebaseAuthError.message}
                                                </div>
                                            </div>
                                        )}
                                        <div className='col-sm-12'>
                                            <p className='form-row form-row-wide'>
                                                <input
                                                    name='email'
                                                    type='text'
                                                    className='input-text'
                                                    placeholder={
                                                        wording.homePage
                                                            .dialogSignIn.email
                                                    }
                                                    value={
                                                        register.values.email
                                                    }
                                                    onChange={event =>
                                                        this.handleInputChange(
                                                            'register',
                                                            event
                                                        )
                                                    }
                                                />
                                                <span className='error'>
                                                    {this.hasError(
                                                        'register',
                                                        'email'
                                                    )
                                                        ? register.errors
                                                              .email[0]
                                                        : null}
                                                </span>
                                            </p>
                                        </div>

                                        <div className='col-sm-12'>
                                            <p className='form-row form-row-wide'>
                                                <input
                                                    name='password'
                                                    type='password'
                                                    className='input-text'
                                                    placeholder={
                                                        wording.homePage
                                                            .dialogSignIn
                                                            .password
                                                    }
                                                    value={
                                                        register.values.password
                                                    }
                                                    onChange={event =>
                                                        this.handleInputChange(
                                                            'register',
                                                            event
                                                        )
                                                    }
                                                />
                                                <span className='error'>
                                                    {this.hasError(
                                                        'register',
                                                        'password'
                                                    )
                                                        ? register.errors
                                                              .password[0]
                                                        : null}
                                                </span>
                                            </p>
                                        </div>

                                        <div className='col-sm-12'>
                                            <p className='form-row form-row-wide'>
                                                <input
                                                    name='name'
                                                    type='text'
                                                    className='input-text'
                                                    placeholder='Name'
                                                    value={register.values.name}
                                                    onChange={event =>
                                                        this.handleInputChange(
                                                            'register',
                                                            event
                                                        )
                                                    }
                                                />
                                                <span className='error'>
                                                    {this.hasError(
                                                        'register',
                                                        'name'
                                                    )
                                                        ? register.errors
                                                              .name[0]
                                                        : null}
                                                </span>
                                            </p>
                                        </div>

                                        <div className='col-sm-12'>
                                            <p className='form-row form-row-wide'>
                                                <input
                                                    name='lastname'
                                                    type='text'
                                                    className='input-text'
                                                    placeholder='Last name'
                                                    value={
                                                        register.values.lastname
                                                    }
                                                    onChange={event =>
                                                        this.handleInputChange(
                                                            'register',
                                                            event
                                                        )
                                                    }
                                                />
                                                <span className='error'>
                                                    {this.hasError(
                                                        'register',
                                                        'lastname'
                                                    )
                                                        ? register.errors
                                                              .lastname[0]
                                                        : null}
                                                </span>
                                            </p>
                                        </div>
                                    </div>

                                    <div className='dialog-action row'>
                                        <div className='col-md-12'>
                                            <button
                                                disabled={!register.isValid}
                                                className='w-100 btn btn-lg btn-login'
                                                onClick={() => {
                                                    CreateUserWithEmailAndPassword(
                                                        register.values.email,
                                                        register.values
                                                            .password,
                                                        register.values.name,
                                                        register.values.lastname
                                                    );
                                                    this.clearFormInput();
                                                }}>
                                                {
                                                    wording.homePage
                                                        .dialogSignIn.signUp
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}

                            {isSignInForm === 'forget-password' && (
                                <>
                                    <div className='row row-10'>
                                        <div className='col-sm-12'>
                                            <h4
                                                className='title-forget-password'
                                                style={{ color: '#c6c7c7' }}>
                                                {
                                                    wording.homePage
                                                        .dialogSignIn
                                                        .resetPassword
                                                }
                                            </h4>
                                            <p className='sub-title-forget-password'>
                                                {
                                                    wording.homePage
                                                        .dialogSignIn.subReset
                                                }
                                            </p>
                                        </div>

                                        {firebaseAuthError && (
                                            <div className='col-sm-12'>
                                                <div
                                                    className='alert alert-danger'
                                                    role='alert'>
                                                    {firebaseAuthError.message}
                                                </div>
                                            </div>
                                        )}

                                        {firebaseResetEmail && (
                                            <div className='col-sm-12'>
                                                <div
                                                    className='alert alert-success'
                                                    role='alert'>
                                                    {firebaseResetEmail.message}
                                                </div>
                                            </div>
                                        )}

                                        <div className='col-sm-12'>
                                            <p className='form-row form-row-wide'>
                                                <input
                                                    name='email'
                                                    type='text'
                                                    className='input-text'
                                                    placeholder={
                                                        wording.homePage
                                                            .dialogSignIn.email
                                                    }
                                                    value={reset.values.email}
                                                    onChange={event =>
                                                        this.handleInputChange(
                                                            'reset',
                                                            event
                                                        )
                                                    }
                                                />
                                                <span className='error'>
                                                    {this.hasError(
                                                        'reset',
                                                        'email'
                                                    )
                                                        ? reset.errors.email[0]
                                                        : null}
                                                </span>
                                            </p>
                                        </div>
                                    </div>

                                    <div className='dialog-action row'>
                                        <div className='col-md-12'>
                                            <button
                                                disabled={!reset.isValid}
                                                className='w-100 btn btn-lg btn-login'
                                                onClick={() => {
                                                    FirebaseForgetPassword(
                                                        reset.values.email
                                                    );
                                                    this.clearFormInput();
                                                }}>
                                                {
                                                    wording.homePage
                                                        .dialogSignIn.buttonSent
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className='mt-30' />
                            <div
                                className='dialog-ask row row-10'
                                style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>
                                <div className='col-md-7'>
                                    <p className='ask'>
                                        {isSignInForm === 'sign-in' &&
                                            `${wording.homePage.dialogSignIn.dontAccount}`}
                                        {isSignInForm !== 'sign-in' &&
                                            `${wording.homePage.dialogSignIn.alreadyHaveAnAccount}`}
                                    </p>
                                </div>
                                <div className='col-md-5'>
                                    {isSignInForm === 'sign-in' && (
                                        <button
                                            className='w-100 btn btn-lg btn-ask'
                                            onClick={() =>
                                                FormChange('sign-up')
                                            }>
                                            {
                                                wording.homePage.dialogSignIn
                                                    .signUp
                                            }
                                        </button>
                                    )}

                                    {isSignInForm !== 'sign-in' && (
                                        <button
                                            className='w-100 btn btn-lg btn-ask'
                                            onClick={() =>
                                                FormChange('sign-in')
                                            }>
                                            {
                                                wording.homePage.dialogSignIn
                                                    .signIn
                                            }
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = ({ login, language }) => ({
    isSignInForm: login.isSignInForm,
    dialogLogin: login.dialogLogin,
    firebaseAuthError: login.firebaseAuthError,
    firebaseResetEmail: login.firebaseResetEmail,
    wording: language.wording
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            CloseDialogLogin: Actions.CloseDialogLogin,
            FormChange: Actions.FormChange,
            SignInWithFacebook: Actions.SignInWithFacebook,
            SignWithEmainAndPassword: Actions.SignWithEmainAndPassword,
            CreateUserWithEmailAndPassword:
                Actions.CreateUserWithEmailAndPassword,
            FirebaseForgetPassword: Actions.FirebaseForgetPassword
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(DialogLogin);
